export interface SatNoteCopy {
  body: string[];
  button: string;
}

export const STANDARD_COPY: SatNoteCopy = {
  body: [
    'By signing this satisfaction note, you confirm that the goods/services have been delivered/installed satisfactorily and in line with the terms of your contract.',
    'You will now be responsible for your repayments and we will now pay the retailer on your behalf for the goods/services you have now confirmed have been received satisfactorily. We will send you a reminder of your repayment details for your reference.',
    'You acknowledge that it is your responsibility to register or do anything that the retailer may require in order to register the relevant product warranties and recognize that failure to do so invalidates any protection you receive from such warranties.',
  ],
  button: 'I agree that I have received the goods/services satisfactorily.',
};

export const SUPPLY_ONLY_COPY: SatNoteCopy = {
  body: [
    'By signing this satisfaction note, you confirm that the goods have been delivered and are in line with the terms of your contract.',
    'You will now be responsible for your repayments and we will now pay the retailer on your behalf for the goods you have now confirmed have been received satisfactorily. We will send you a reminder of your repayment details for your reference.',
    "You acknowledge that fitting/installation is your responsibility and doesn't form a part of this contract. Further, you acknowledge that it is your responsibility to register the relevant product warranties and recognise that failure to do so invalidates any protection you receive from such warranties.",
  ],
  button: 'I agree that I have received the goods satisfactorily.',
};

export const INTRODUCED_COPY: SatNoteCopy = {
  body: [
    'By signing this delivery note, you confirm that the initial delivery* has been received.',
    'You will now be responsible for your repayments and we have paid your tradesperson to enable them to pay off their Howdens Trade Account. The lender will send you a reminder of your repayment details for reference.',
    "You acknowledge that fitting/installation is your responsibility and doesn't form a part of this contract. Further, you acknowledge that it is your responsibility to register the relevant product warranties and recognise that failure to do so invalidates any protection you receive from such warranties.",
  ],
  button: 'I agree that I have received the initial delivery* satisfactorily.',
};
